import { PillTheme } from "@redotech/redo-model/pill-theme";
import classNames from "classnames";
import { memo } from "react";
import {
  RedoBadge,
  RedoBadgeColor,
} from "../arbiter-components/badge/redo-badge";
import XIcon from "../icon-old/x.svg";
import * as conversationTagPillCss from "./conversation-tag-pill.module.css";

interface ConversationTagLike {
  name: string;
  pillTheme: PillTheme;
}

export const ConversationTagPill = memo(function ConversationTagPill({
  tag,
  xClicked,
  showOverflow = false,
}: {
  tag: ConversationTagLike;
  xClicked?(): void;
  showOverflow?: boolean;
}) {
  return (
    <div
      className={classNames(
        conversationTagPillCss.pillWrapper,
        showOverflow && conversationTagPillCss.showOverflow,
      )}
    >
      <RedoBadge
        color={BadgePillThemeToColorMapping[tag.pillTheme]}
        iconTrailing={
          xClicked
            ? { type: "icon", onClick: xClicked, Icon: XIcon }
            : undefined
        }
        size="sm"
        text={tag.name}
      />
    </div>
  );
});

const BadgePillThemeToColorMapping: Record<PillTheme, RedoBadgeColor> = {
  [PillTheme.NORMAL]: "gray",
  [PillTheme.PRIMARY_LIGHT]: "purple",
  [PillTheme.LIGHT_PINK]: "pink",
  [PillTheme.DANGER]: "orange",
  [PillTheme.NEUTRAL_YELLOW]: "warning",
  [PillTheme.SUCCESS]: "success",
  [PillTheme.NEUTRAL_BLUE]: "blueLight",
  [PillTheme.PRIMARY]: "purple",
  [PillTheme.SOLID_PINK]: "pink",
  [PillTheme.SOLID_RED]: "error",
  [PillTheme.SOLID_ORANGE]: "orange",
  [PillTheme.SOLID_YELLOW]: "warning",
  [PillTheme.SOLID_GREEN]: "success",
  [PillTheme.SOLID_LIGHT_BLUE]: "blue",
  [PillTheme.SOLID_NAVY]: "indigo",
  [PillTheme.SOLID_BLACK]: "black",
  [PillTheme.SOLID_WHITE]: "white",
};
